module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="well" style="font-size: 14px;">\n    <div class="form form-inline center">\n        <div class="form-group">\n            <label class="control-label" for="org-name-from">Organization: </label>\n            <select id="org-name-from" name="orgNameFrom" class="form-control input-sm letter-range-filter-field" style="width:auto;">\n                ';
 _.each(upperCaseChars, function(ucc) { 
__p+='\n                ';
 if (ucc == orgNameFrom) { 
__p+='\n                <option value="'+
((__t=( ucc ))==null?'':__t)+
'" name="'+
((__t=( ucc ))==null?'':__t)+
'" selected> '+
((__t=( ucc ))==null?'':__t)+
'</option>\n                ';
 } else { 
__p+='\n                <option value="'+
((__t=( ucc ))==null?'':__t)+
'" name="'+
((__t=( ucc ))==null?'':__t)+
'"> '+
((__t=( ucc ))==null?'':__t)+
'</option>\n                ';
 } 
__p+='\n                ';
 }) 
__p+='\n            </select>\n            <label class="control-label" for="org-name-to">-</label>\n            <select id="org-name-to" name="orgNameTo" class="form-control input-sm letter-range-filter-field" style="width:auto;">\n                ';
 _.each(upperCaseChars, function(ucc) { 
__p+='\n                ';
 if (ucc == orgNameTo || !orgNameTo && ucc == "Z") { 
__p+='\n                <option value="'+
((__t=( ucc ))==null?'':__t)+
'" name="'+
((__t=( ucc ))==null?'':__t)+
'" selected> '+
((__t=( ucc ))==null?'':__t)+
'</option>\n                ';
 } else { 
__p+='\n                <option value="'+
((__t=( ucc ))==null?'':__t)+
'" name="'+
((__t=( ucc ))==null?'':__t)+
'"> '+
((__t=( ucc ))==null?'':__t)+
'</option>\n                ';
 } 
__p+='\n                ';
 }) 
__p+='\n            </select>\n            <label class="control-label" for="md-name-from" style="margin-left: 20px;">Physician: </label>\n            <select id="md-name-from" name="mdNameFrom" class="form-control input-sm letter-range-filter-field" style="width:auto;">\n                ';
 _.each(upperCaseChars, function(ucc) { 
__p+='\n                ';
 if (ucc == mdNameFrom) { 
__p+='\n                <option value="'+
((__t=( ucc ))==null?'':__t)+
'" name="'+
((__t=( ucc ))==null?'':__t)+
'" selected> '+
((__t=( ucc ))==null?'':__t)+
'</option>\n                ';
 } else { 
__p+='\n                <option value="'+
((__t=( ucc ))==null?'':__t)+
'" name="'+
((__t=( ucc ))==null?'':__t)+
'"> '+
((__t=( ucc ))==null?'':__t)+
'</option>\n                ';
 } 
__p+='\n                ';
 }) 
__p+='\n            </select>\n            <label class="control-label" for="md-name-to">-</label>\n            <select id="md-name-to" name="mdNameTo" class="form-control input-sm letter-range-filter-field" style="width:auto;">\n                ';
 _.each(upperCaseChars, function(ucc) { 
__p+='\n                ';
 if (ucc == mdNameTo || !mdNameTo && ucc == "Z") { 
__p+='\n                <option value="'+
((__t=( ucc ))==null?'':__t)+
'" name="'+
((__t=( ucc ))==null?'':__t)+
'" selected> '+
((__t=( ucc ))==null?'':__t)+
'</option>\n                ';
 } else { 
__p+='\n                <option value="'+
((__t=( ucc ))==null?'':__t)+
'" name="'+
((__t=( ucc ))==null?'':__t)+
'"> '+
((__t=( ucc ))==null?'':__t)+
'</option>\n                ';
 } 
__p+='\n                ';
 }) 
__p+='\n            </select>\n            <label class="control-label" for="contact-value" style="margin-left: 20px;">Destination: </label>\n            <input type="text" class="form-control" id="contact-value" name="contact-value" placeholder="Destination" value="'+
((__t=( contactValue ))==null?'':__t)+
'"/>\n        </div>\n        <div class="form-group" style="display: none">\n            <div class="btn-group" id="sending-method" style="display: list-item;margin-left: 20px;">\n                ';
 _.each(_.keys(contactTypes), function(method){ 
__p+='\n                <a class="btn btn-primary btn-sm '+
((__t=( sendingMethodsState[method] ))==null?'':__t)+
'" data-title="'+
((__t=( method ))==null?'':__t)+
'">'+
((__t=( contactTypes[method] ))==null?'':__t)+
'</a>\n                ';
 }) 
__p+='\n            </div>\n        </div>\n        ';
 _.each(_.keys(contactTypes), function(method){ 
__p+='\n        <label class="checkbox"><input type="checkbox" class="contact-type" value="'+
((__t=( method ))==null?'':__t)+
'" style="margin-left: 20px; vertical-align: center;"\n            ';
 if (sendingMethodsState[method] == 'active') { 
__p+=' checked ';
 } 
__p+=' />'+
((__t=( contactTypes[method] ))==null?'':__t)+
'</label>\n        ';
 }) 
__p+='\n    </div>\n\n</div>\n<div>\n    <div style="font-size: 14px;">\n        <input id="aggregates"/>\n    </div>\n    <button id="apply-aggregates" class="btn btn-primary">Apply</button>\n</div>\n\n<hr>\n\n<div class="form form-horizontal" style="margin-left: 18px;font-size: 16px;">\n    ';
 if (!_.isEmpty(tree.children)) { 
__p+='\n    <div class="col-md-12 col-xs-12 row" style="margin-bottom: 10px;">\n        <div class="col-md-8 col-xs-8">\n            <span class="pull-left clickable expand-collapse-all">\n                <i class="fa fa-plus-square" aria-hidden="true" title="Expand All"></i>\n            </span>\n            ';
 _.each(aggregatesCaptionsList, function(caption, index) { 
__p+='\n            <div class="col-md-2 col-xs-2"><b>'+
((__t=( caption ))==null?'':__t)+
'</b></div>\n            ';
 }) 
__p+='\n        </div>\n        <div class="col-md-4 col-xs-4 center">\n            <div class="col-md-2 col-xs-2 center" id="pending"><b>Pending</b></div>\n            <div class="col-md-2 col-xs-2 center" id="viewed" style="display: none;"><b>Viewed</b></div>\n            <div class="col-md-2 col-xs-2 center" id="signed"><b>Signed</b></div>\n            <div class="col-md-4 col-xs-4 center" id="under"><b>Under Review</b></div>\n            <div class="col-md-2 col-xs-2 center" id="deleted"><b>Obsolete</b></div>\n            <div class="col-md-2 col-xs-2 center" id="unreviewed" style="display: none;"><b>Not Assigned</b></div>\n            <div class="col-md-2 col-xs-2 center" id="total"><b>Total</b></div>\n        </div>\n    </div>\n    ';
 } else { 
__p+='\n    <div>\n        <div class="center"><b>There are no data. Please, select aggregate values and Apply.</b></div>\n    </div>\n    ';
 } 
__p+='\n\n    ';
 _.each(getChildrenValues(tree.children, 0), function(firstLevelNode, firstLevelIndex) { 
__p+='\n        <div class="level-group">\n            <div class="col-md-12 col-xs-12 row first-level-node">\n                <div class="col-md-8 col-xs-8">\n                    ';
 if (!_.isEmpty(firstLevelNode.children)) { 
__p+='\n                    <a data-toggle="collapse" href="#'+
((__t=( generateCollapseId(firstLevelNode, 0, [firstLevelIndex]) ))==null?'':__t)+
'"\n                       id="'+
((__t=( generateCollapseId(firstLevelNode, 0, [firstLevelIndex]) + '_control' ))==null?'':__t)+
'"\n                       role="button" aria-expanded="false" aria-controls="'+
((__t=( generateCollapseId(firstLevelNode, 0, [firstLevelIndex]) ))==null?'':__t)+
'">\n                        <span><i class="fa fa-plus-square-o" aria-hidden="true"></i></span>\n                    </a>\n                    <input type="checkbox" class="doc-group-select document-checkbox" title="Select all documents"\n                           data-id="'+
((__t=( nodeId(firstLevelNode, 0) ))==null?'':__t)+
'" data-index="0">\n                    ';
 } 
__p+='\n                    <b>'+
((__t=( nodeNameOrAsLink(firstLevelNode, 0) ))==null?'':__t)+
'</b>\n                </div>\n                <div class="col-md-4 col-xs-4 center">\n                    <div class="col-md-2 col-xs-2 center">\n                        ';
 if (nodeNameIsNoValue(firstLevelNode, 0)){ 
__p+='\n                        '+
((__t=( firstLevelNode.pending ))==null?'':__t)+
'\n                        ';
 } else { 
__p+='\n                        <a href="'+
((__t=( pendingLink([firstLevelNode]) ))==null?'':__t)+
'"  target="_blank">'+
((__t=( firstLevelNode.pending ))==null?'':__t)+
'</a>\n                        ';
 } 
__p+='\n                    </div>\n                    <div class="col-md-2 col-xs-2 center" style="display: none;">\n                        ';
 if (nodeNameIsNoValue(firstLevelNode, 0)){ 
__p+='\n                        '+
((__t=( firstLevelNode.viewed ))==null?'':__t)+
'\n                        ';
 } else { 
__p+='\n                        <a href="'+
((__t=( viewedLink([firstLevelNode]) ))==null?'':__t)+
'"  target="_blank">'+
((__t=( firstLevelNode.viewed ))==null?'':__t)+
'</a>\n                        ';
 } 
__p+='\n                    </div>\n                    <div class="col-md-2 col-xs-2 center">\n                        ';
 if (nodeNameIsNoValue(firstLevelNode, 0)){ 
__p+='\n                        '+
((__t=( firstLevelNode.signed ))==null?'':__t)+
'\n                        ';
 } else { 
__p+='\n                        <a href="'+
((__t=( signedLink([firstLevelNode]) ))==null?'':__t)+
'"  target="_blank">'+
((__t=( firstLevelNode.signed ))==null?'':__t)+
'</a>\n                        ';
 } 
__p+='\n                    </div>\n                    <div class="col-md-4 col-xs-4 center">\n                        ';
 if (nodeNameIsNoValue(firstLevelNode, 0)){ 
__p+='\n                        '+
((__t=( firstLevelNode.under ))==null?'':__t)+
'\n                        ';
 } else { 
__p+='\n                        <a href="'+
((__t=( underReviewLink([firstLevelNode]) ))==null?'':__t)+
'"  target="_blank">'+
((__t=( firstLevelNode.under ))==null?'':__t)+
'</a>\n                        ';
 } 
__p+='\n                    </div>\n                    <div class="col-md-2 col-xs-2 center">\n                        ';
 if (nodeNameIsNoValue(firstLevelNode, 0)){ 
__p+='\n                        '+
((__t=( firstLevelNode.deleted ))==null?'':__t)+
'\n                        ';
 } else { 
__p+='\n                        <a href="'+
((__t=( deletedLink([firstLevelNode]) ))==null?'':__t)+
'"  target="_blank">'+
((__t=( firstLevelNode.deleted ))==null?'':__t)+
'</a>\n                        ';
 } 
__p+='\n                    </div>\n                    <div class="col-md-2 col-xs-2 center" style="display: none;">\n                        ';
 if (nodeNameIsNoValue(firstLevelNode, 0)){ 
__p+='\n                        '+
((__t=( firstLevelNode.unreviewed ))==null?'':__t)+
'\n                        ';
 } else { 
__p+='\n                        <a href="'+
((__t=( unreviewedLink([firstLevelNode]) ))==null?'':__t)+
'"  target="_blank">'+
((__t=( firstLevelNode.unreviewed ))==null?'':__t)+
'</a>\n                        ';
 } 
__p+='\n                    </div>\n                    <div class="col-md-2 col-xs-2 center">\n                        ';
 if (nodeNameIsNoValue(firstLevelNode, 0)){ 
__p+='\n                        '+
((__t=( firstLevelNode.total ))==null?'':__t)+
'\n                        ';
 } else { 
__p+='\n                        <a href="'+
((__t=( totalLink([firstLevelNode]) ))==null?'':__t)+
'"  target="_blank">'+
((__t=( firstLevelNode.total ))==null?'':__t)+
'</a>\n                        ';
 } 
__p+='\n                    </div>\n                </div>\n            </div>\n\n            <div class="collapse expandable" id="'+
((__t=( generateCollapseId(firstLevelNode, 0, [firstLevelIndex]) ))==null?'':__t)+
'">\n\n                ';
 _.each(getChildrenValues(firstLevelNode.children, 1), function(secondLevelNode, secondLevelIndex) { 
__p+='\n                <div class="level-group">\n\n                    <div class="col-md-12 col-xs-12 row second-level-node">\n                        <div class="col-md-7 col-xs-7 col-md-offset-1 col-xs-offset-1" style="padding-left: 70px;">\n                            ';
 if (!_.isEmpty(secondLevelNode.children)) { 
__p+='\n                            <a data-toggle="collapse" href="#'+
((__t=( generateCollapseId(secondLevelNode, 1, [firstLevelIndex, secondLevelIndex]) ))==null?'':__t)+
'"\n                               id="'+
((__t=( generateCollapseId(secondLevelNode, 1, [firstLevelIndex, secondLevelIndex]) + '_control' ))==null?'':__t)+
'"\n                               role="button" aria-expanded="false" aria-controls="'+
((__t=( generateCollapseId(secondLevelNode, 1, [firstLevelIndex, secondLevelIndex]) ))==null?'':__t)+
'">\n                                <span><i class="fa fa-plus-square-o" aria-hidden="true"></i></span>\n                            </a>\n                            <input type="checkbox" class="doc-group-select document-checkbox" title="Select all documents"\n                                   data-id="'+
((__t=( nodeId(secondLevelNode, 1) ))==null?'':__t)+
'" data-index="1">\n                            ';
 } else { 
__p+='\n                            <a href="/api/document/view/'+
((__t=( nodeId(secondLevelNode, 1) ))==null?'':__t)+
'" target="_blank" title="View">\n                                <span class="clickable glyphicon glyphicon-eye-open"/>\n                            </a>\n                            <input type="checkbox" class="doc-select document-checkbox" name="'+
((__t=( secondLevelNode['DOCUMENT'] ))==null?'':__t)+
'">\n                            ';
 } 
__p+='\n                            <b>'+
((__t=( nodeNameOrAsLink(secondLevelNode, 1) ))==null?'':__t)+
'</b>\n                        </div>\n                        <div class="col-md-4 col-xs-4 center">\n                            <div class="col-md-2 col-xs-2 center">\n                                ';
 if (nodeNameIsNoValue(secondLevelNode, 1)){ 
__p+='\n                                '+
((__t=( secondLevelNode.pending ))==null?'':__t)+
'\n                                ';
 } else { 
__p+='\n                                <a href="'+
((__t=( pendingLink([firstLevelNode, secondLevelNode]) ))==null?'':__t)+
'"  target="_blank">'+
((__t=( secondLevelNode.pending ))==null?'':__t)+
'</a>\n                                ';
 } 
__p+='\n                            </div>\n                            <div class="col-md-2 col-xs-2 center" style="display: none;">\n                                ';
 if (nodeNameIsNoValue(secondLevelNode, 1)){ 
__p+='\n                                '+
((__t=( secondLevelNode.viewed ))==null?'':__t)+
'\n                                ';
 } else { 
__p+='\n                                <a href="'+
((__t=( viewedLink([firstLevelNode, secondLevelNode]) ))==null?'':__t)+
'"  target="_blank">'+
((__t=( secondLevelNode.viewed ))==null?'':__t)+
'</a>\n                                ';
 } 
__p+='\n                            </div>\n                            <div class="col-md-2 col-xs-2 center">\n                                ';
 if (nodeNameIsNoValue(secondLevelNode, 1)){ 
__p+='\n                                '+
((__t=( secondLevelNode.signed ))==null?'':__t)+
'\n                                ';
 } else { 
__p+='\n                                <a href="'+
((__t=( signedLink([firstLevelNode, secondLevelNode]) ))==null?'':__t)+
'"  target="_blank">'+
((__t=( secondLevelNode.signed ))==null?'':__t)+
'</a>\n                                ';
 } 
__p+='\n                            </div>\n                            <div class="col-md-4 col-xs-4 center">\n                                ';
 if (nodeNameIsNoValue(secondLevelNode, 1)){ 
__p+='\n                                '+
((__t=( secondLevelNode.under ))==null?'':__t)+
'\n                                ';
 } else { 
__p+='\n                                <a href="'+
((__t=( underReviewLink([firstLevelNode, secondLevelNode]) ))==null?'':__t)+
'"  target="_blank">'+
((__t=( secondLevelNode.under ))==null?'':__t)+
'</a>\n                                ';
 } 
__p+='\n                            </div>\n                            <div class="col-md-2 col-xs-2 center">\n                                ';
 if (nodeNameIsNoValue(secondLevelNode, 1)){ 
__p+='\n                                '+
((__t=( secondLevelNode.deleted ))==null?'':__t)+
'\n                                ';
 } else { 
__p+='\n                                <a href="'+
((__t=( deletedLink([firstLevelNode, secondLevelNode]) ))==null?'':__t)+
'"  target="_blank">'+
((__t=( secondLevelNode.deleted ))==null?'':__t)+
'</a>\n                                ';
 } 
__p+='\n                            </div>\n                            <div class="col-md-2 col-xs-2 center" style="display: none;">\n                                ';
 if (nodeNameIsNoValue(secondLevelNode, 1)){ 
__p+='\n                                '+
((__t=( secondLevelNode.unreviewed ))==null?'':__t)+
'\n                                ';
 } else { 
__p+='\n                                <a href="'+
((__t=( unreviewedLink([firstLevelNode, secondLevelNode]) ))==null?'':__t)+
'"  target="_blank">'+
((__t=( secondLevelNode.unreviewed ))==null?'':__t)+
'</a>\n                                ';
 } 
__p+='\n                            </div>\n                            <div class="col-md-2 col-xs-2 center">\n                                ';
 if (nodeNameIsNoValue(secondLevelNode, 1)){ 
__p+='\n                                '+
((__t=( secondLevelNode.total ))==null?'':__t)+
'\n                                ';
 } else { 
__p+='\n                                <a href="'+
((__t=( totalLink([firstLevelNode, secondLevelNode]) ))==null?'':__t)+
'"  target="_blank">'+
((__t=( secondLevelNode.total ))==null?'':__t)+
'</a>\n                                ';
 } 
__p+='\n                            </div>\n                        </div>\n                    </div>\n\n                    <div class="collapse expandable" id="'+
((__t=( generateCollapseId(secondLevelNode, 1, [firstLevelIndex, secondLevelIndex]) ))==null?'':__t)+
'">\n                        ';
 _.each(getChildrenValues(secondLevelNode.children, 2), function(thirdLevelNode, thirdLevelIndex) { 
__p+='\n                        <div class="level-group">\n                            <div class="col-md-12 col-xs-12 row second-level-node">\n                                <div class="col-md-6 col-xs-6 col-md-offset-2 col-xs-offset-2" style="padding-left: 90px;">\n                                    ';
 if (!_.isEmpty(thirdLevelNode.children)) { 
__p+='\n                                    <a data-toggle="collapse" href="#'+
((__t=( generateCollapseId(thirdLevelNode, 2, [firstLevelIndex, secondLevelIndex, thirdLevelIndex]) ))==null?'':__t)+
'"\n                                       id="'+
((__t=( generateCollapseId(thirdLevelNode, 2, [firstLevelIndex, secondLevelIndex, thirdLevelIndex]) + '_control' ))==null?'':__t)+
'"\n                                       role="button" aria-expanded="false" aria-controls="'+
((__t=( generateCollapseId(thirdLevelNode, 2, [firstLevelIndex, secondLevelIndex, thirdLevelIndex]) ))==null?'':__t)+
'">\n                                        <span><i class="fa fa-plus-square-o" aria-hidden="true"></i></span>\n                                    </a>\n                                    <input type="checkbox" class="doc-group-select document-checkbox" title="Select all documents"\n                                           data-id="'+
((__t=( nodeId(thirdLevelNode, 2) ))==null?'':__t)+
'" data-index="2">\n                                    ';
 } else { 
__p+='\n                                    <a href="/api/document/view/'+
((__t=( nodeId(thirdLevelNode, 2) ))==null?'':__t)+
'" target="_blank" title="View">\n                                        <span class="clickable glyphicon glyphicon-eye-open"/>\n                                    </a>\n                                    <input type="checkbox" class="doc-select document-checkbox" name="'+
((__t=( thirdLevelNode['DOCUMENT'] ))==null?'':__t)+
'">\n                                    ';
 } 
__p+='\n                                    <b>'+
((__t=( nodeNameOrAsLink(thirdLevelNode, 2) ))==null?'':__t)+
'</b>\n                                </div>\n                                <div class="col-md-4 col-xs-4 center">\n                                    <div class="col-md-2 col-xs-2 center">\n                                        ';
 if (nodeNameIsNoValue(thirdLevelNode, 2)){ 
__p+='\n                                        '+
((__t=( thirdLevelNode.pending ))==null?'':__t)+
'\n                                        ';
 } else { 
__p+='\n                                        <a href="'+
((__t=( pendingLink([firstLevelNode, secondLevelNode, thirdLevelNode]) ))==null?'':__t)+
'"  target="_blank">'+
((__t=( thirdLevelNode.pending ))==null?'':__t)+
'</a>\n                                        ';
 } 
__p+='\n                                    </div>\n                                    <div class="col-md-2 col-xs-2 center" style="display: none;">\n                                        ';
 if (nodeNameIsNoValue(thirdLevelNode, 2)){ 
__p+='\n                                        '+
((__t=( thirdLevelNode.viewed ))==null?'':__t)+
'\n                                        ';
 } else { 
__p+='\n                                        <a href="'+
((__t=( viewedLink([firstLevelNode, secondLevelNode, thirdLevelNode]) ))==null?'':__t)+
'"  target="_blank">'+
((__t=( thirdLevelNode.viewed ))==null?'':__t)+
'</a>\n                                        ';
 } 
__p+='\n                                    </div>\n                                    <div class="col-md-2 col-xs-2 center">\n                                        ';
 if (nodeNameIsNoValue(thirdLevelNode, 2)){ 
__p+='\n                                        '+
((__t=( thirdLevelNode.signed ))==null?'':__t)+
'\n                                        ';
 } else { 
__p+='\n                                        <a href="'+
((__t=( signedLink([firstLevelNode, secondLevelNode, thirdLevelNode]) ))==null?'':__t)+
'"  target="_blank">'+
((__t=( thirdLevelNode.signed ))==null?'':__t)+
'</a>\n                                        ';
 } 
__p+='\n                                    </div>\n                                    <div class="col-md-4 col-xs-4 center">\n                                        ';
 if (nodeNameIsNoValue(thirdLevelNode, 2)){ 
__p+='\n                                        '+
((__t=( thirdLevelNode.under ))==null?'':__t)+
'\n                                        ';
 } else { 
__p+='\n                                        <a href="'+
((__t=( underReviewLink([firstLevelNode, secondLevelNode, thirdLevelNode]) ))==null?'':__t)+
'"  target="_blank">'+
((__t=( thirdLevelNode.under ))==null?'':__t)+
'</a>\n                                        ';
 } 
__p+='\n                                    </div>\n                                    <div class="col-md-2 col-xs-2 center">\n                                        ';
 if (nodeNameIsNoValue(thirdLevelNode, 2)){ 
__p+='\n                                        '+
((__t=( thirdLevelNode.deleted ))==null?'':__t)+
'\n                                        ';
 } else { 
__p+='\n                                        <a href="'+
((__t=( deletedLink([firstLevelNode, secondLevelNode, thirdLevelNode]) ))==null?'':__t)+
'"  target="_blank">'+
((__t=( thirdLevelNode.deleted ))==null?'':__t)+
'</a>\n                                        ';
 } 
__p+='\n                                    </div>\n                                    <div class="col-md-2 col-xs-2 center" style="display: none;">\n                                        ';
 if (nodeNameIsNoValue(thirdLevelNode, 2)){ 
__p+='\n                                        '+
((__t=( thirdLevelNode.unreviewed ))==null?'':__t)+
'\n                                        ';
 } else { 
__p+='\n                                        <a href="'+
((__t=( unreviewedLink([firstLevelNode, secondLevelNode, thirdLevelNode]) ))==null?'':__t)+
'"  target="_blank">'+
((__t=( thirdLevelNode.unreviewed ))==null?'':__t)+
'</a>\n                                        ';
 } 
__p+='\n                                    </div>\n                                    <div class="col-md-2 col-xs-2 center">\n                                        ';
 if (nodeNameIsNoValue(thirdLevelNode, 2)){ 
__p+='\n                                        '+
((__t=( thirdLevelNode.total ))==null?'':__t)+
'\n                                        ';
 } else { 
__p+='\n                                        <a href="'+
((__t=( totalLink([firstLevelNode, secondLevelNode, thirdLevelNode]) ))==null?'':__t)+
'"  target="_blank">'+
((__t=( thirdLevelNode.total ))==null?'':__t)+
'</a>\n                                        ';
 } 
__p+='\n                                    </div>\n                                </div>\n                            </div>\n\n                            <div class="collapse expandable" id="'+
((__t=( generateCollapseId(thirdLevelNode, 2, [firstLevelIndex, secondLevelIndex, thirdLevelIndex]) ))==null?'':__t)+
'">\n                                ';
 _.each(getChildrenValues(thirdLevelNode.children, 3), function(fourthLevelNode, fourthLevelIndex) { 
__p+='\n                                <div class="col-md-12 col-xs-12 row third-level-node">\n                                    <div class="col-md-5 col-xs-5 col-md-offset-3 col-xs-offset-3" style="padding-left: 120px;">\n                                        <a href="/api/document/view/'+
((__t=( nodeId(fourthLevelNode, 3) ))==null?'':__t)+
'" target="_blank" title="View">\n                                            <span class="clickable glyphicon glyphicon-eye-open"/>\n                                        </a>\n                                        <input type="checkbox" class="doc-select document-checkbox" name="'+
((__t=( fourthLevelNode['DOCUMENT'] ))==null?'':__t)+
'">\n                                        <b>'+
((__t=( nodeNameOrAsLink(fourthLevelNode, 3) ))==null?'':__t)+
'</b>\n                                    </div>\n                                    <div class="col-md-4 col-xs-4 center">\n                                        <div class="col-md-2 col-xs-2 center">\n                                            ';
 if (nodeNameIsNoValue(fourthLevelNode, 3)){ 
__p+='\n                                            '+
((__t=( fourthLevelNode.pending ))==null?'':__t)+
'\n                                            ';
 } else { 
__p+='\n                                            <a href="'+
((__t=( pendingLink([firstLevelNode, secondLevelNode, thirdLevelNode, fourthLevelNode]) ))==null?'':__t)+
'"  target="_blank">'+
((__t=( fourthLevelNode.pending ))==null?'':__t)+
'</a>\n                                            ';
 } 
__p+='\n                                        </div>\n                                        <div class="col-md-2 col-xs-2 center" style="display: none;">\n                                            ';
 if (nodeNameIsNoValue(fourthLevelNode, 3)){ 
__p+='\n                                            '+
((__t=( fourthLevelNode.viewed ))==null?'':__t)+
'\n                                            ';
 } else { 
__p+='\n                                            <a href="'+
((__t=( viewedLink([firstLevelNode, secondLevelNode, thirdLevelNode, fourthLevelNode]) ))==null?'':__t)+
'"  target="_blank">'+
((__t=( fourthLevelNode.viewed ))==null?'':__t)+
'</a>\n                                            ';
 } 
__p+='\n                                        </div>\n                                        <div class="col-md-2 col-xs-2 center">\n                                            ';
 if (nodeNameIsNoValue(fourthLevelNode, 3)){ 
__p+='\n                                            '+
((__t=( fourthLevelNode.signed ))==null?'':__t)+
'\n                                            ';
 } else { 
__p+='\n                                            <a href="'+
((__t=( signedLink([firstLevelNode, secondLevelNode, thirdLevelNode, fourthLevelNode]) ))==null?'':__t)+
'"  target="_blank">'+
((__t=( fourthLevelNode.signed ))==null?'':__t)+
'</a>\n                                            ';
 } 
__p+='\n                                        </div>\n                                        <div class="col-md-4 col-xs-4 center">\n                                            ';
 if (nodeNameIsNoValue(fourthLevelNode, 3)){ 
__p+='\n                                            '+
((__t=( fourthLevelNode.under ))==null?'':__t)+
'\n                                            ';
 } else { 
__p+='\n                                            <a href="'+
((__t=( underReviewLink([firstLevelNode, secondLevelNode, thirdLevelNode, fourthLevelNode]) ))==null?'':__t)+
'"  target="_blank">'+
((__t=( fourthLevelNode.under ))==null?'':__t)+
'</a>\n                                            ';
 } 
__p+='\n                                        </div>\n                                        <div class="col-md-2 col-xs-2 center">\n                                            ';
 if (nodeNameIsNoValue(fourthLevelNode, 3)){ 
__p+='\n                                            '+
((__t=( fourthLevelNode.deleted ))==null?'':__t)+
'\n                                            ';
 } else { 
__p+='\n                                            <a href="'+
((__t=( deletedLink([firstLevelNode, secondLevelNode, thirdLevelNode, fourthLevelNode]) ))==null?'':__t)+
'"  target="_blank">'+
((__t=( fourthLevelNode.deleted ))==null?'':__t)+
'</a>\n                                            ';
 } 
__p+='\n                                        </div>\n                                        <div class="col-md-2 col-xs-2 center" style="display: none;">\n                                            ';
 if (nodeNameIsNoValue(fourthLevelNode, 3)){ 
__p+='\n                                            '+
((__t=( fourthLevelNode.unreviewed ))==null?'':__t)+
'\n                                            ';
 } else { 
__p+='\n                                            <a href="'+
((__t=( unreviewedLink([firstLevelNode, secondLevelNode, thirdLevelNode, fourthLevelNode]) ))==null?'':__t)+
'"  target="_blank">'+
((__t=( fourthLevelNode.unreviewed ))==null?'':__t)+
'</a>\n                                            ';
 } 
__p+='\n                                        </div>\n                                        <div class="col-md-2 col-xs-2 center">\n                                            ';
 if (nodeNameIsNoValue(fourthLevelNode, 3)){ 
__p+='\n                                            '+
((__t=( fourthLevelNode.total ))==null?'':__t)+
'\n                                            ';
 } else { 
__p+='\n                                            <a href="'+
((__t=( totalLink([firstLevelNode, secondLevelNode, thirdLevelNode, fourthLevelNode]) ))==null?'':__t)+
'"  target="_blank">'+
((__t=( fourthLevelNode.total ))==null?'':__t)+
'</a>\n                                            ';
 } 
__p+='\n                                        </div>\n                                    </div>\n                                </div>\n                                ';
 }) 
__p+='\n                            </div>\n                        </div>\n                        ';
 }) 
__p+='\n                    </div>\n                </div>\n                ';
 }) 
__p+='\n            </div>\n        </div>\n    ';
 }) 
__p+='\n\n    <hr>\n    <div style="margin-bottom: 50px;">\n        <button type="button" class="btn btn-success btn-sm action-btn" style="margin-top: 10px;" id="agg-stat-download" title="DOWNLOAD" disabled>\n            <i class="fa fa-download" aria-hidden="true"></i>\n        </button>\n        <button type="button" class="btn btn-success btn-sm action-btn" style="margin-top: 10px;" id="agg-stat-print" title="PRINT ALL SELECTED" disabled>\n            <i class="fa fa-print" aria-hidden="true"></i>\n        </button>\n        <button type="button" class="btn btn-success btn-sm action-btn" style="margin-top: 10px;" id="agg-sign-all" title="SIGN" disabled>\n            <i class="fa fa-pencil" aria-hidden="true"></i>\n        </button>\n        <button type="button" class="btn btn-success btn-sm action-btn" style="margin-top: 10px;" id="agg-addendum" title="ADD ADDENDUM" disabled>\n            <i class="fa fa-file-o" aria-hidden="true"></i>\n        </button>\n        <button type="button" class="btn btn-primary btn-sm action-btn" style="margin-top: 10px;" id="agg-stat-assign" disabled>RE-ASSIGN</button>\n        <button type="button" class="btn btn-primary btn-sm action-btn" style="margin-top: 10px;" id="agg-stat-add-patient" disabled>ADD PATIENT</button>\n        <button type="button" class="btn btn-primary btn-sm action-btn" style="margin-top: 10px;" id="agg-stat-set-due" title="SET DUE" disabled>\n            <i class="fa fa-clock-o" aria-hidden="true"></i>\n        </button>\n        <button type="button" class="btn btn-primary btn-sm action-btn" style="margin-top: 10px;" id="agg-stat-audit" title="AUDIT" disabled>\n            <i class="fa fa-comment-o" aria-hidden="true"></i>\n        </button>\n        <button type="button" class="btn btn-primary btn-sm action-btn" style="margin-top: 10px;" id="agg-stat-send" title="SEND" disabled>\n            <i class="fa fa-envelope-o" aria-hidden="true"></i>\n        </button>\n        <div class="btn-group dropright">\n            <button type="button" class="btn btn-primary dropdown-toggle btn-sm action-btn" style="margin-top: 10px;" id="agg-stat-mark-as"\n                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" disabled>\n                Mark As\n            </button>\n            <ul class="dropdown-menu">\n                <li class="clickable"><a id="agg-stat-mark-as-sent">Sent</a></li>\n                <li class="clickable"><a id="agg-stat-mark-as-delivered">Delivered</a></li>\n            </ul>\n        </div>\n        <button type="button" class="btn btn-primary btn-sm action-btn" style="margin-top: 10px;" id="agg-stat-open-selected"\n                title="Open selected documents in a new window" disabled>\n            <i class="fa fa-list" aria-hidden="true"></i>\n        </button>\n    </div>\n\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/statistics/documents-statistics-aggregate-view.html
// module id = 306
// module chunks = 0